module.exports = __webpack_public_path__ + "img/icon-activity-email-active.33a63961.svg";